import classes from './Popup.module.scss';
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon, Button } from 'components/common/Elements/Elements';

import Header from './Header/Header';
import Body from './Body/Body';
import Footer from './Footer/Footer';

function Popup(props) {
  let {
    children,
    onClose,
    preventClosing,
    className,
    baseClassName,
    center,
    hideCloseButton
  } = props;

  let goBack = useCallback(
    event => {
      if (!preventClosing) {
        onClose(event);
      }
    },
    [preventClosing, onClose]
  );

  function onOverlayClick(event) {
    if (event.target === event.currentTarget) {
      goBack(event);
    }
  }

  useEffect(() => {
    function onKeyDown(event) {
      if (
        event.key === 'Escape' ||
        event.key === 'Esc' ||
        event.keyCode === 27
      ) {
        event.preventDefault();
        goBack(event);
        return false;
      }

      return true;
    }

    window.addEventListener('keydown', onKeyDown, true);
    document.querySelector('body').style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown, true);
      document.querySelector('body').style.overflow = 'auto';
    };
  }, [goBack]);

  return (
    <div role="presentation" className={cn(classes.base, baseClassName)}>
      <div
        className={classes.overlay}
        onClick={!hideCloseButton ? onOverlayClick : null}
      />
      <div
        className={cn(
          {
            [classes.center]: center
          },
          className,
          classes.popup
        )}
      >
        {!hideCloseButton && (
          <Button
            className={classes.closeButton}
            onClick={onClose}
            disabled={preventClosing}
            title="close modal"
          >
            <Icon icon={'closeCircle'} className={classes.icon} size="24px" />
          </Button>
        )}
        {children}
      </div>
    </div>
  );
}

Popup.Header = Header;
Popup.Body = Body;
Popup.Footer = Footer;

Popup.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onClose: PropTypes.func.isRequired,
  preventClosing: PropTypes.bool,
  className: PropTypes.string,
  baseClassName: PropTypes.string,
  hideCloseButton: PropTypes.bool
};

export default Popup;
